import { orderTypeConstants } from "constants/order";

export const ORDER_TYPE_DESCRIPTIONS: Record<string, string> = {
  [orderTypeConstants.GFE]: "Full insurance-based estimate with eligibility",
  [orderTypeConstants.PATIENT_RESPONSIBILITY]:
    "Known balance the patient owes - no eligibility needed",
  [orderTypeConstants.BUNDLED]:
    "Cash / bundled package price — no eligibility needed",
};

export function withPatientEstimateFirst<T extends { value: string }>(
  orderTypeValues: T[]
): T[] {
  return [
    ...orderTypeValues.filter(
      (orderType) => orderType.value === orderTypeConstants.GFE
    ),
    ...orderTypeValues.filter(
      (orderType) => orderType.value !== orderTypeConstants.GFE
    ),
  ];
}
